export type AssistSourceKind = "KNOWLEDGE_BASE" | "WEBSITE";

export interface AssistSource {
    title: string;
    kind: AssistSourceKind;
    url?: string | null;
}

const COLLEGE_SCORECARD_URL = "https://collegescorecard.ed.gov/";
const NCAA_URL = "https://www.ncaa.org/";

function httpUrl(value: unknown): string | null {
    if (typeof value !== "string") {
        return null;
    }
    const trimmed = value.trim();
    return /^https?:\/\//i.test(trimmed) ? trimmed : null;
}

export function parseAssistSources(raw: unknown): AssistSource[] {
    if (!Array.isArray(raw)) {
        return [];
    }
    const seen = new Set<string>();
    const sources: AssistSource[] = [];
    for (const item of raw) {
        if (!item || typeof item !== "object") {
            continue;
        }
        const record = item as { title?: unknown; kind?: unknown; url?: unknown; category?: unknown };
        const title = typeof record.title === "string" ? record.title.trim() : "";
        const category = typeof record.category === "string" ? record.category.trim() : "";
        const haystack = `${title} ${category}`.toLowerCase();
        let url = httpUrl(record.url) ?? httpUrl(category);
        if (!url && haystack.includes("college scorecard")) {
            url = COLLEGE_SCORECARD_URL;
        }
        if (!url && haystack.includes("ncaa sports programs")) {
            url = NCAA_URL;
        }
        const kind: AssistSourceKind =
            record.kind === "WEBSITE"
                ? "WEBSITE"
                : record.kind === "KNOWLEDGE_BASE"
                  ? "KNOWLEDGE_BASE"
                  : url ||
                      haystack.includes("college scorecard") ||
                      haystack.includes("ncaa sports programs") ||
                      category.toUpperCase() === "COLLEGE"
                    ? "WEBSITE"
                    : "KNOWLEDGE_BASE";
        if (!title && !url) {
            continue;
        }
        const resolvedTitle = title || url || "Source";
        const key = `${kind}|${resolvedTitle.toLowerCase()}|${url ?? ""}`;
        if (seen.has(key)) {
            continue;
        }
        seen.add(key);
        sources.push({ title: resolvedTitle, kind, url });
    }
    return sources;
}

export function sourceKindLabel(kind: AssistSourceKind): string {
    return kind === "WEBSITE" ? "Website" : "Polaris Knowledge Base";
}
